module.exports = __webpack_public_path__ + "static/media/document-duplicate.d0a563f1.svg";